import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import feature1 from "../assets/images/feature-1.png";
import feature2 from "../assets/images/feature-2.png";
import feature3 from "../assets/images/feature-3.png";
import feature4 from "../assets/images/feature-4.png";
import { Button,notification } from "antd";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import styled from "styled-components";
import { green } from "../constants/colors";
import { baseUrl } from "../utills";
import { useNavigate } from "react-router-dom";
import { CiHeart } from "react-icons/ci";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { IoIosHeart } from "react-icons/io";
import axios from "axios";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 250 },
    items: 1.2,
    slidesToSlide: 1.2,
  },
};

const sliderItems = [
  {
    image: feature1,
    alt: "feature 1",
    text: "PKR 25,000",
    description: "Toyota Corolla",
  },
  {
    image: feature2,
    alt: "feature 2",
    text: "PKR 30,000",
    description: "Honda Civic",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "PKR 35,000",
    description: "Ford Focus",
  },
  {
    image: feature4,
    alt: "feature 4",
    text: "PKR 40,000",
    description: "Chevrolet Malibu",
  },
  {
    image: feature1,
    alt: "feature 1",
    text: "PKR 25,000",
    description: "Toyota Corolla",
  },
  {
    image: feature2,
    alt: "feature 2",
    text: "PKR 30,000",
    description: "Honda Civic",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "PKR 35,000",
    description: "Ford Focus",
  },
  {
    image: feature4,
    alt: "feature 4",
    text: "PKR 40,000",
    description: "Chevrolet Malibu",
  },
];

const CustomButtonGroupContainer = styled.div`
  position: absolute;
  top: -80px;
  right: 50px;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    transform: unset;
    top: -50px;
    right: 20px;
  }
`;

const CustomButton = styled(Button)`
  background-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  font-size: 20px;
  color: lightgray !important;
  padding: 5px !important;
  color: #333;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${green} !important;
    border-color: ${green} !important;
    color: white !important;
  }
`;

const CustomButtonGroup = ({ next, previous }) => {
  return (
    <CustomButtonGroupContainer className="custom-button-group">
      <CustomButton onClick={previous} className="custom-prev-button">
        <MdOutlineArrowBackIos />
      </CustomButton>
      <CustomButton onClick={next} className="custom-next-button">
        <MdOutlineArrowForwardIos />
      </CustomButton>
    </CustomButtonGroupContainer>
  );
};

const SlideContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  :hover & {
    cursor: pointer;
  }
  //    &:hover::after {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(0, 0, 0, 0.4); /* Adjust opacity for darkness */
  //   transition: background 0.3s ease-in-out;
  // }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 96%;
  border-radius: 10px;
  overflow: hidden;
  background:#F4EBEB;
`;

const GradientOverlay = styled.div`
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;
  // background: linear-gradient(
  //   to bottom,
  //   rgba(0, 0, 0, 0.3) 0%,
  //   rgba(0, 0, 0, 0.6) 100%
  // );
  // z-index: 1;
`;

const SlideImage = styled.img`
  width: 100%;
  height: 240px;
  display: block;
`;

const SlideContent = styled.div`
  // position: absolute;
  padding: 6px 0;
  width: 85% !important;
  margin: 0 auto;
  // bottom: 3%;
  left: 0;
  right: 0;
  color: #122243 !important;
  // z-index: 1 !important;
  // transition: transform 0s ease-in-out;
  // ${SlideContainer}:hover & {
  //   transform: translateY(-75%);
  // }
`;

const SlideContent2 = styled.div`
  border-top: 1px solid gray;
  // position: absolute;
  width: 85% !important;
  margin: 0 auto;
  padding: 10px 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #122243;
  // z-index: 1 !important;
  // transform: translateY(100%);
  // transition: transform 0.7s ease-in-out;
  // ${SlideContainer}:hover & {
  //   transform: translateY(0);
  // }
`;
const StyledNotification = styled.div`
.custom-notification {
  z-index: 9999 !important;
}
`;
const Slider = ({fetchCarPosts,data}) => {
  console.log("data in carousel",data);
  const navigate= useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const token = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("user_id");

  const openNotification = (pauseOnHover, title) => {
      api.open({
        message: title,
        description: (
          <p
            className="cursor-pointer text-blue-500"
            onClick={() => navigate("/layout/ads/my-saved-ads")}
          >
            View all saved ads
          </p>
        ),
        icon: (
          // !save ? (
          <FaHeart className="text-[22px] text-red-500 cursor-pointer" />
        ),
        // ) : (
        //   <FaRegHeart className="text-[22px] cursor-pointer" />
        // ),
        showProgress: true,
        pauseOnHover,
        className: "custom-notification",
      });
    };
  const onClick = async (favorite, car_post_id) => {
    console.log("fav:::", favorite);
    
    const payload = {
      car_post_id: car_post_id,
      favorite: favorite === true ? false : true,
      user_id: user_id,
    };
    try {
      const res = await axios.post(baseUrl + "car-posts/favorite", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("save car", res);
      if (res.status === 200) {
        // setSavedData(res?.data);
        // setLoading(false);
        // setSave(!save);
        fetchCarPosts();

        openNotification(true, res?.data?.detail);
      } else {
        // setLoading(false);
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };
  return (
    <div className="parent" style={{ position: "relative" }}>
      <StyledNotification>{contextHolder}</StyledNotification>

      <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        partialVisible={false}
        customButtonGroup={<CustomButtonGroup />}
        renderButtonGroupOutside={true}
        arrows={false} // Hide the default arrows
      >
        {data?.map((item, index) => (
          <SlideContainer key={index} 
           >
             <p onClick={() => onClick(item?.favorite, item?.id)} className="group z-[9999] bg-[white] hover hover:bg-[#fc382d] h-[30px] w-[30px] flex justify-center items-center rounded rounded-[100%] text-[14px] font-[500] text-center absolute top-3 right-5">
                {item?.favorite? <IoIosHeart className="text-[#fc382d] group-hover:text-white" style={{fontSize:"18px",}}/>:<CiHeart className="text-gray group-hover:text-white" style={{fontSize:"18px"}}/>}
              </p>
            <ImageWrapper 
             onClick={()=>
              navigate(`/car-details/${item?.id}`, {
                state: {
                  data: item,
                },
              })
            }
           >

              <SlideImage
              
               src={`${baseUrl}${item?.attachments[0]}`} alt={item.alt} />
              <GradientOverlay
             
              >

              </GradientOverlay>
              <p className="text-[#FFFFFF] bg-[#C73336] z-10 w-[70px] h-[25px] rounded rounded-[4px] pb-[0.5px] text-[14px] font-[500] text-center absolute top-4 left-2 flex justify-center items-center">featured</p>

              <SlideContent>
                <h3 className="text-[20px] font-bold">{item?.price}</h3>
                <p className="text-[16px] font-[500]">{item?.car_maker?.car_maker} {item?.car_model?.model_name} {item?.car_version?.manufacture_end_year}</p>
              </SlideContent>
              <SlideContent2>
                <div className="flex gap-14 items-center mb-2">
                  <p className="text-[14px] font-[500]">{item?.mileage_km ? (item.mileage_km * 0.621371).toFixed(1) : 0} miles</p>
                  <p className="text-[14px] font-[500]">{item?.engine_type?.engine_type}</p>
                </div>
                <p className="text-[16px] font-600">{item?.transmission?.transmission_type}</p>
              </SlideContent2>
            </ImageWrapper>
          </SlideContainer>
        ))}
      </Carousel>
    </div>
  );
};

export default Slider;
